import React, {
	Component,
} from "react";
import {
	View,
	StyleSheet,
} from "react-native";

var styles = StyleSheet.create({
	videoContainer: {
		flex: 1,
		alignSelf: "stretch",
	},
});

var videoStyle = {
	position: "absolute",
	top: 0,
	bottom: 0,
	left: 0,
	right: 0,
	width: "100%",
	height: "100%",
	objectPosition: "center center",
	objectFit: "contain",
};

export default class VideoView extends Component {
	constructor(props){
		super(props);
		this._handle_video_element = handle_video_element.bind(this);
		this.videoElement = null;
	}

	componentDidUpdate(prevProps) {
		if (prevProps.stream !== this.props.stream && this.videoElement) updateVideoStream(this.videoElement, this.props.stream);
	}

	render() {
		var props = this.props;
		var key = props.stream ? (props.stream.id || "stream") : "loading";
		return (
			<View style={styles.videoContainer}>
				<video
					key={key}
					id={props.id}
					style={videoStyle}
					autoPlay
					playsInline
					muted={!!props.muted}
					ref={(video) => {
						this.videoElement = video;
						this._handle_video_element(video);
					}}
				/>
			</View>
		);
	}
}

function handle_video_element(video) {
	if(!video) return;
	var props = this.props;
	var stream = props.stream;

	updateVideoStream(video, stream);
}

function updateVideoStream(video, stream) {
	if (!video || !stream) {
		if (video)
			if ("srcObject" in video) video.srcObject = null;
			else if (video.src) {
				window.URL.revokeObjectURL(video.src);
				video.src = "";
			}
		return;
	}

	var hasActiveTracks = stream.getTracks && stream.getTracks().some(track => track.readyState === "live");
	if (!hasActiveTracks) return;

	if ("srcObject" in video) {
		if (video.srcObject !== stream) video.srcObject = stream;
	} else {
		// Legacy browser support - avoid using this in new browsers
		if (video.src) window.URL.revokeObjectURL(video.src);
		video.src = window.URL.createObjectURL(stream);
	}
}
